import { render, staticRenderFns } from "./MerchandiseReportTab.vue?vue&type=template&id=b4152f6a"
import script from "./MerchandiseReportTab.vue?vue&type=script&lang=js"
export * from "./MerchandiseReportTab.vue?vue&type=script&lang=js"
import style0 from "./MerchandiseReportTab.vue?vue&type=style&index=0&id=b4152f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports